module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-daterangepicker",
    class: _vm.focusBool ? 'is-active' : ''
  }, [_c('rt-date-picker', {
    staticClass: "rt-date-picker",
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.computedStartPlaceholder,
      "value": _vm.startDate,
      "disabled": _vm.computedDisabled,
      "format": _vm.format,
      "picker-options": _vm.startPickerOptions,
      "clear-icon-right": _vm.clearIconRight
    },
    on: {
      "focus": _vm.focusInput,
      "blur": _vm.focusInput,
      "input": function (v) { return _vm.DateChange(v, 'startDate'); }
    }
  }), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), _c('rt-date-picker', {
    ref: "datePicker",
    attrs: {
      "type": _vm.type,
      "placeholder": _vm.computedEndPlaceholder,
      "value": _vm.endDate,
      "disabled": _vm.endDisabled || _vm.computedDisabled,
      "format": _vm.format,
      "picker-options": _vm.endPickerOptions,
      "clear-icon-right": _vm.clearIconRight
    },
    on: {
      "focus": _vm.endStartFocus,
      "blur": _vm.focusInput,
      "input": function (v) { return _vm.DateChange(v, 'endDate'); }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39aae45e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/form/rtDateRangePicker.vue
// module id = 2066
// module chunks = 228